import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';

import AsyncSelector from 'common/components/selectors/AsyncSelector';

import { getAsyncOptions, getInitialAsyncValues } from 'utils/helpers';

const CombinedAggragate = ({ fields, selectField, isEditDisabled }) => {
  return (
    <Row className="flex-nowrap" noGutters>
      <Col className="overflow-hidden">
        <AsyncSelector
          onChange={selectField('rank')}
          type="crew-ranks"
          disabled={isEditDisabled}
          className={`${fields.rank?.error ? 'mb-1' : 'mb-0'} w-100p`}
          getOptionValue={option => option.id}
          getOptionLabel={option => option.name}
          loadOptions={search => getAsyncOptions(search, 'crew-ranks')}
          defaultOptions={() => getInitialAsyncValues('crew-ranks', null, null)}
          isClearable={false}
          {...fields.rank}
        />
      </Col>

      <Col xs="auto" className="fs-12 fw-medium text-primary align-items-center d-flex cpx-12">
        and
      </Col>

      <Col className="overflow-hidden">
        <AsyncSelector
          onChange={selectField('second_rank')}
          type="crew-ranks"
          disabled={isEditDisabled}
          className={`${fields.second_rank?.error ? 'mb-1' : 'mb-0'} w-100p `}
          getOptionValue={option => option.id}
          getOptionLabel={option => option.name}
          loadOptions={search => getAsyncOptions(search, 'crew-ranks')}
          defaultOptions={() => getInitialAsyncValues('crew-ranks', null, null)}
          isClearable={false}
          filterOption={option => option.value !== fields.rank?.value?.id}
          {...fields.second_rank}
        />
      </Col>
    </Row>
  );
};

export default CombinedAggragate;

CombinedAggragate.propTypes = {
  changeField: PropTypes.func,
  isDateJoined: PropTypes.bool,
  showHeader: PropTypes.bool,
  isEditDisabled: PropTypes.bool,
  fields: PropTypes.shape({
    aggregation_type: PropTypes.shape({ value: PropTypes.object, error: PropTypes.string }),
    rank: PropTypes.shape({ value: PropTypes.object, error: PropTypes.string }),
    second_rank: PropTypes.shape({ value: PropTypes.object, error: PropTypes.string }),
    threshold: PropTypes.shape({ value: PropTypes.string, error: PropTypes.string }),
    type_id: PropTypes.shape({ value: PropTypes.number, error: PropTypes.string })
  })
};
